document.addEventListener('DOMContentLoaded', () => {

    // --- DOM Elements ---
    const cartToggles = document.getElementById('cart-toggles');
    const cartSidebar = document.getElementById('cart-sidebar');
    const closeCartBtn = document.getElementById('close-cart');
    const cartOverlay = document.getElementById('cart-overlay');
    const cartItemsContainer = document.getElementById('cart-items');
    const cartCountSpan = document.querySelector('.cart-count');
    const cartTotalPrice = document.getElementById('cart-total-price');
    const checkoutBtn = document.querySelector('.checkout-btn');

    // --- Mobile Menu Elements ---
    const mobileMenuToggle = document.getElementById('mobile-menu-toggle');
    const mobileMenuSidebar = document.getElementById('mobile-menu-sidebar');
    const closeMobileMenuBtn = document.getElementById('close-mobile-menu');
    const mobileMenuOverlay = document.getElementById('mobile-menu-overlay');
    const mobileLinks = document.querySelectorAll('.mobile-link');

    // --- Hero Carousel Logic ---
    const heroSlides = document.querySelectorAll('.hero-slide');
    if (heroSlides.length > 1) {
        let currentSlide = 0;
        setInterval(() => {
            heroSlides[currentSlide].classList.remove('active');
            currentSlide = (currentSlide + 1) % heroSlides.length;
            heroSlides[currentSlide].classList.add('active');
        }, 5000); // Change image every 5 seconds
    }

    // --- Functions ---
    const toggleCart = (e) => {
        if (e) e.preventDefault();
        cartSidebar.classList.toggle('active');
        cartOverlay.classList.toggle('active');
    }

    // Toggle Mobile Menu open/close
    const toggleMobileMenu = (e) => {
        if (e) e.preventDefault();
        mobileMenuSidebar.classList.toggle('active');
        mobileMenuOverlay.classList.toggle('active');
    }

    const formatMoney = (cents) => {
        const value = Math.round(cents / 100);
        const money = value.toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        return `$${money} COP`;
    }

    const fetchCart = () => {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                renderCart(cart);
            });
    }

    const renderCart = (cart) => {
        if (cartCountSpan) cartCountSpan.textContent = cart.item_count;
        if (cartTotalPrice) cartTotalPrice.textContent = formatMoney(cart.total_price);

        if (cartItemsContainer) {
            cartItemsContainer.innerHTML = '';
            if (cart.items.length === 0) {
                cartItemsContainer.innerHTML = '<p class="empty-cart-msg">Tu carrito está vacío, ¡Añade frescura!</p>';
                return;
            }

            cart.items.forEach((item) => {
                const itemElement = document.createElement('div');
                itemElement.classList.add('cart-item');

                // Handle variant title if its not Default Title
                let variantText = '';
                if (item.variant_title && item.variant_title !== 'Default Title') {
                    variantText = ` - ${item.variant_title}`;
                }

                let priceHTML = '';
                if (item.original_line_price > item.final_line_price) {
                    priceHTML = `
                        <span class="cart-item-price" style="color:red; font-weight:bold;">${formatMoney(item.final_line_price)}</span>
                        <span class="cart-item-price" style="text-decoration:line-through; font-size:0.85rem; margin-left:5px;">${formatMoney(item.original_line_price)}</span>
                    `;
                } else {
                    priceHTML = `<span class="cart-item-price">${formatMoney(item.line_price)}</span>`;
                }

                itemElement.innerHTML = `
                    <div class="cart-item-info">
                        <span class="cart-item-title">${item.product_title}${variantText}</span>
                        <div>${priceHTML}</div>
                        <div class="cart-qty-selector">
                            <button class="cart-qty-btn cart-minus" data-key="${item.key}" data-qty="${item.quantity - 1}">-</button>
                            <input type="number" class="cart-qty-input" value="${item.quantity}" min="0">
                            <button class="cart-qty-btn cart-plus" data-key="${item.key}" data-qty="${item.quantity + 1}">+</button>
                        </div>
                    </div>
                    <button class="remove-item" data-key="${item.key}">Eliminar</button>
                `;

                cartItemsContainer.appendChild(itemElement);
            });

            // Add event listeners for remove buttons
            document.querySelectorAll('.remove-item').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    const key = e.target.getAttribute('data-key');
                    updateCartQuantity(key, 0); // Reuse logic
                });
            });

            // Add event listeners for quantity buttons
            document.querySelectorAll('.cart-qty-btn').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    const key = e.target.getAttribute('data-key');
                    const qty = parseInt(e.target.getAttribute('data-qty'));
                    if (qty >= 0) {
                        e.target.disabled = true;
                        updateCartQuantity(key, qty);
                    }
                });
            });

            // Add event listeners for direct quantity input
            document.querySelectorAll('.cart-qty-input').forEach(input => {
                input.addEventListener('change', (e) => {
                    const key = e.target.previousElementSibling.getAttribute('data-key');
                    const qty = parseInt(e.target.value);
                    if (qty >= 0) {
                        e.target.disabled = true; // prevent multiple triggers
                        updateCartQuantity(key, qty);
                    } else {
                        // Reset to 0 if invalid
                        updateCartQuantity(key, 0);
                    }
                });
            });
        }
    }

    const updateCartQuantity = (key, quantity) => {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: key,
                quantity: quantity
            })
        })
            .then(response => response.json())
            .then(cart => {
                renderCart(cart);
            });
    }

    // Keeping function for backwards compatibility or safety if referenced anywhere else
    const removeFromCart = (key) => {
        updateCartQuantity(key, 0);
    }

    // --- Event Listeners ---
    if (cartToggles) cartToggles.addEventListener('click', toggleCart);
    if (closeCartBtn) closeCartBtn.addEventListener('click', toggleCart);
    if (cartOverlay) cartOverlay.addEventListener('click', toggleCart);

    // Mobile Menu Listeners
    if (mobileMenuToggle) mobileMenuToggle.addEventListener('click', toggleMobileMenu);
    if (closeMobileMenuBtn) closeMobileMenuBtn.addEventListener('click', toggleMobileMenu);
    if (mobileMenuOverlay) mobileMenuOverlay.addEventListener('click', toggleMobileMenu);

    // Close mobile menu when a link is clicked
    mobileLinks.forEach(link => {
        link.addEventListener('click', () => {
            if (mobileMenuSidebar.classList.contains('active')) {
                toggleMobileMenu();
            }
        });
    });

    // Initial Cart Fetch
    fetchCart();

    // Intercept Add to Cart Forms (AJAX Cart)
    const addForms = document.querySelectorAll('form[action="/cart/add"]');
    addForms.forEach(form => {
        form.addEventListener('submit', (e) => {
            e.preventDefault();

            const submitBtn = form.querySelector('[type="submit"]');
            let originalText = 'Agregar al carrito';
            if (submitBtn) {
                originalText = submitBtn.textContent;
                submitBtn.textContent = 'Añadiendo...';
                submitBtn.disabled = true;
            }

            const formData = new FormData(form);

            fetch('/cart/add.js', {
                method: 'POST',
                body: formData
            })
                .then(response => response.json())
                .then(item => {
                    fetchCart();
                    if (cartSidebar && !cartSidebar.classList.contains('active')) {
                        toggleCart();
                    }
                })
                .catch(error => {
                    console.error('Error adding to cart:', error);
                    alert('No se pudo agregar al carrito');
                })
                .finally(() => {
                    if (submitBtn) {
                        submitBtn.textContent = originalText;
                        submitBtn.disabled = false;
                    }
                });
        });
    });

    // Checkout via Shopify
    if (checkoutBtn) {
        // Redirigir al checkout nativo de Shopify en lugar de Whatsapp
        const oldCheckoutClick = checkoutBtn.onclick;
        checkoutBtn.replaceWith(checkoutBtn.cloneNode(true));
        const newCheckoutBtn = document.querySelector('.checkout-btn');
        newCheckoutBtn.addEventListener('click', () => {
            fetch('/cart.js')
                .then(r => r.json())
                .then(cart => {
                    if (cart.item_count > 0) {
                        window.location.href = '/checkout';
                    } else {
                        alert('Tu carrito está vacío.');
                    }
                })
        });
    }

    // Handle form submission prevent default for distributor
    const distributorForm = document.querySelector('.distributor-form');
    if (distributorForm) {
        distributorForm.addEventListener('submit', (e) => {
            e.preventDefault();
            alert('¡Gracias por tu interés! Te contactaremos pronto para que seas parte de la familia Syrus.');
            distributorForm.reset();
        });
    }
});
